import * as angular from 'angular';

import {contactus} from './contactus';

export const contactusModule = 'contactus'

angular
  .module(contactusModule, [])
  .component('contactus', contactus)



// WEBPACK FOOTER //
// ./src/app/contactus/contactus.index.ts